import { Component, OnInit } from '@angular/core';
import { PartnerUserService } from '../../../services/partner-user.service';
import { finalize, switchMap } from 'rxjs';
import { SessionStorageService } from '../../../services/session-storage.service';

@Component({
  selector: 'app-components-partner-overview',
  templateUrl: './overview.component.html'
})
export class OverviewComponent implements OnInit {
  partner: Boo.Objects.Partner;
  partnerManager: Boo.Objects.PartnerUserIdentity;

  isLoading = true;

  constructor(
    private sessionStorageService: SessionStorageService,
    private partnerUserService: PartnerUserService) {
  }

  ngOnInit(): void {
    this.sessionStorageService.getPartner()
      .pipe(
        finalize(() => this.isLoading = false),
        switchMap((partner: Boo.Objects.Partner) => {
          this.partner = partner;
          return this.partnerUserService.getByPartnerUserId(partner.PartnerManagerUserId);
        })
      )
      .subscribe({
        next: (partnerManager) => {
          this.partnerManager = partnerManager;
        },
        error: (err) => toastr.error(err)
      });
  }
}